import { useEffect, useState } from "react";
import { useI18n } from "../i18n/LocaleProvider";
import { normalizeAnalyticsWindow } from "../../core/analyticsWindows";
import { fetchDashboardForecast } from "./api";

export default function useDashboardForecast({ activeSubscription = false } = {}) {
  const { locale } = useI18n();
  const [windowKey, setWindowKey] = useState("30d");
  const [state, setState] = useState({
    loading: true,
    error: "",
    data: null,
  });

  useEffect(() => {
    setWindowKey((current) => normalizeAnalyticsWindow(current, activeSubscription));
  }, [activeSubscription]);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const normalizedWindow = normalizeAnalyticsWindow(windowKey, activeSubscription);
      setState((prev) => ({
        loading: true,
        error: "",
        data: prev.data,
      }));
      try {
        const data = await fetchDashboardForecast(locale, normalizedWindow);
        if (cancelled) return;
        setState({ loading: false, error: "", data });
      } catch (error) {
        if (cancelled) return;
        setState((prev) => ({
          loading: false,
          error: error?.message || "dashboard_forecast_load_failed",
          data: prev.data,
        }));
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [locale, windowKey, activeSubscription]);

  const updateWindow = (nextWindow) => {
    setWindowKey(normalizeAnalyticsWindow(nextWindow, activeSubscription));
  };

  return {
    ...state,
    windowKey: normalizeAnalyticsWindow(windowKey, activeSubscription),
    setWindowKey: updateWindow,
    hasData: Boolean(state.data),
  };
}
